<form class="form-inline search-full" [class.open]="navServices.search">
  <div class="form-group w-100 mb-0 item-search">
    <input class="form-control-plaintext" [(ngModel)]="text" [ngModelOptions]="{ standalone: true }" (keyup)="searchTerm(text)" type="text" autocomplete="off" placeholder="Search.." />
    <button type="button" class="close-search header-icon-btn" aria-label="Close search" (click)="searchToggle()">
      <app-feather-icons [icon]="'x'"></app-feather-icons>
    </button>
    @if (menuItems?.length) {
      <div class="Typeahead-menu" [class.is-open]="searchResult" id="search-outer">
        @for (menuItem of menuItems | slice : 0 : 8; track menuItem) {
          <div class="ProfileCard u-cf">
            <div class="ProfileCard-avatar">
              <app-svg-icon [icon]="menuItem.icon" class="header-search"></app-svg-icon>
            </div>
            <div class="ProfileCard-details">
              <div class="ProfileCard-realName">
                <a [routerLink]="menuItem?.path" class="realname" (click)="removeFix()">{{ menuItem?.title }}</a>
              </div>
            </div>
          </div>
        }
      </div>
    }
    <div class="Typeahead-menu" [class.is-open]="searchResultEmpty">
      <div class="tt-dataset tt-dataset-0">
        <div class="EmptyMessage">Opps!! There are no result found.</div>
      </div>
    </div>
  </div>
</form>
